import React from 'react';

import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import ArrowLeft from '@/assets/icon/Olybet/arrow-left.svg';
import BingolyLogo from '@/assets/images/Olybet/bingoly.svg';

import { useAuth } from '@/hooks/useAuth';
import { useSettings } from '@/hooks/useSettings.hook';

import LangSwitcher from '@/components/LangSwitcher';

import { RoutesEnum } from '@/enums/routes.enum';

import { tKeys } from '@/i18n/resourses';

import * as S from './HeaderDesktop.styles';

const HeaderDesktop: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { jwt, onLogout } = useAuth();
  const { pagesWithBackButton } = useSettings();

  return (
    <S.Header id="header">
      <S.Wrapper>
        {pagesWithBackButton ? (
          <S.BackToPrevPage onClick={() => navigate(RoutesEnum.play)}>
            <S.ChevronLeft alt="" src={ArrowLeft} />
            <S.BackToGameZoneText>{t(tKeys.back)}</S.BackToGameZoneText>
          </S.BackToPrevPage>
        ) : null}

        <S.LogoBox>
          <Link to={RoutesEnum.play}>
            <S.ImageLogo alt="logo" src={BingolyLogo} />
          </Link>
        </S.LogoBox>

        <S.ButtonsBox>
          {jwt && (
            <Button
              onClick={onLogout}
              textTransform="uppercase"
              variant="primary"
            >
              {t(tKeys.logout)}
            </Button>
          )}
          <LangSwitcher />
        </S.ButtonsBox>
      </S.Wrapper>
    </S.Header>
  );
};

export default HeaderDesktop;
